import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { acceptPrivacyPolicy, PRIVACY_POLICY_VERSION } from '../api/users.api';
import WebApp from '@twa-dev/sdk';

type ConsentScreenProps = {
  onConsentAccepted: () => void;
};

export default function ConsentScreen({ onConsentAccepted }: ConsentScreenProps) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleRestart = () => {
    try {
      window.location.reload();
    } catch {
      // ignore
    }
  };

  const handleClose = () => {
    try {
      WebApp.close();
    } catch {
      // ignore
    }
  };

  const handleAccept = async () => {
    setError(null);
    setLoading(true);
    try {
      await acceptPrivacyPolicy({ privacy_policy_version: PRIVACY_POLICY_VERSION });
      onConsentAccepted();
      navigate('/catalog', { replace: true });
    } catch (e) {
      const message =
        e instanceof Error && e.message.trim()
          ? e.message
          : 'Не удалось отправить согласие. Попробуйте позже.';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '70vh',
        padding: '24px',
        textAlign: 'center',
        color: 'var(--text-primary)',
      }}
    >
      <p
        style={{
          fontSize: '16px',
          lineHeight: 1.5,
          marginBottom: '24px',
          maxWidth: '320px',
        }}
      >
        Чтобы пользоваться ботом, нужно согласиться с политикой конфиденциальности.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%', maxWidth: '280px' }}>
        <button
          type="button"
          onClick={() => navigate('/rules')}
          style={{
            padding: '14px 20px',
            borderRadius: '12px',
            border: '1px solid var(--border-soft)',
            backgroundColor: 'var(--bg-surface)',
            color: 'var(--text-primary)',
            fontSize: '15px',
            fontWeight: 500,
            cursor: 'pointer',
          }}
        >
          📄 Правила
        </button>
        <button
          type="button"
          onClick={handleAccept}
          disabled={loading}
          style={{
            padding: '14px 20px',
            borderRadius: '12px',
            border: 'none',
            backgroundColor: 'var(--color-accent)',
            color: 'var(--text-on-accent)',
            fontSize: '15px',
            fontWeight: 600,
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.8 : 1,
          }}
        >
          {loading ? 'Отправка…' : '✅ Согласен'}
        </button>
      </div>

      {error && (
        <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '10px', maxWidth: '320px' }}>
          <p style={{ fontSize: '13px', color: 'var(--color-error)', margin: 0 }}>
            {error}
          </p>
          <p
            style={{
              fontSize: '12px',
              color: 'var(--text-secondary, #666)',
              margin: 0,
              lineHeight: 1.4,
            }}
          >
            Если ошибка повторяется:
            <br />
            1) отключите VPN (если включён);
            <br />
            2) нажмите «Перезапустить» или закройте Mini App;
            <br />
            3) откройте мини‑приложение снова из Telegram (меню бота или кнопка «Открыть»).
          </p>

          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              type="button"
              onClick={handleRestart}
              style={{
                padding: '10px 14px',
                borderRadius: '10px',
                border: '1px solid var(--border-soft)',
                backgroundColor: 'var(--bg-surface)',
                color: 'var(--text-primary)',
                fontSize: '13px',
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              ♻️ Перезапустить
            </button>
            <button
              type="button"
              onClick={handleClose}
              style={{
                padding: '10px 14px',
                borderRadius: '10px',
                border: '1px solid var(--border-soft)',
                backgroundColor: 'var(--bg-surface)',
                color: 'var(--text-primary)',
                fontSize: '13px',
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Закрыть
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
